// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lnyszdpyziyzatyayuku.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxueXN6ZHB5eml5emF0eWF5dWt1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ1NjM5NTIsImV4cCI6MjA3MDEzOTk1Mn0.60u6Rj-vcyJOa5aKkTUHawouDfi97stp94QrXW3zJBo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});